import "./less/styles.less";

import "font-awesome/css/font-awesome.css";

import angular from "angular";
import uiRouter from "angular-ui-router";
import ngAnimate from "angular-animate";
import ngSanitize from "angular-sanitize";
import ngCookies from "angular-cookies";
import ngMessages from "angular-messages";

import logging from "modules/logging";
import angularLoadingBar from "angular-loading-bar";
import analytics from "app/services/analytics.js";
import cookieLaw from "app/services/cookieLaw.js";

//import exceptionHandler from "./app/exceptionHandler";
//import restangular from "app/services/restangular";
import ServiceRA from "./app/services/ServiceRA.js";
import DownloadRA from "./app/services/DownloadRA.js";

import httpCanceler from "./app/interceptors/httpCanceler.js";
import httpInterceptor from "./app/interceptors/httpInterceptor.js";
import httpRequestInterceptor from "./app/interceptors/httpRequestInterceptor.js";
import config from "./app/app.config.js";

import ConfigService from "./app/services/ConfigService";
import Events from "./app/services/Events";

import dtFilter from "./app/filter/dt.js";
import i18nFilter from "./app/filter/i18n.js";
import i18nNoBrFilter from "./app/filter/i18nNoBrFilter.js";
import i18nDirective from "./app/directives/i18n.js";

import AppController from "./app/controller/AppController.js";
import ErrorPageController from "./app/error/ErrorPageController.js";
import RequestService from "app/services/RequestService.js";
import LocaleService from "app/services/LocaleService.js";
import SyscodeService from "app/services/SyscodeService.js";
import AuthenticationService from "modules/dcb-eaccount/services/AuthenticationService";
import FeatureService from "modules/dcb-eaccount/services/FeatureService";
import MenuService from "modules/dcb-eaccount/services/MenuService";
import SessionExpirationService from "modules/dcb-eaccount/services/sessionExpiration";
import MaintenanceService from "app/services/MaintenanceService";
import DemoModeService from "modules/dcb-eaccount/services/DemoModeService.js";

import matchmedia from "app/services/matchmedia.js";
import HeaderComponent from "modules/dcb-eaccount/directives/header-component";
import UserComponent from "modules/dcb-eaccount/directives/user-component";

import routes from "./routes";
// NEU ** import loginRoutes from "modules/login/routes.js";
//import dashboardRoutes from "modules/dashboard/routes.js";
import dashboardModule from "modules/eaDashboard/routes.js";
// import exchangeRateRoutes from "modules/exchangeRates/routes.js";
// import cardRoutes from "modules/cards/routes.js";
// import messageRoutes from "modules/messages/routes.js";

import eaLoginMainModule from "modules/eaLoginMain/routes.js";
import eaChangeEmailModule from "modules/eaLoginMain/eaChangeEmail/routes.js";
import eaAddContractVerificationModule from "modules/eaLoginMain/eaAddContractVerification/routes.js";
import eaForgotEmailModule from "modules/eaLoginMain/eaForgotEmail/routes.js";
import eaForgotPasswordModule from "modules/eaLoginMain/eaForgotPassword/routes.js";
import eaLoginModule from "modules/eaLoginMain/eaLogin/routes.js";
import eaNotAvailableModule from "modules/eaLoginMain/eaNotAvailable/routes.js";
import eaRegisterModule from "modules/eaLoginMain/eaRegister/routes.js";
import eaResetPasswordModule from "modules/eaLoginMain/eaResetPassword/routes.js";
import eaSignupModule from "modules/eaLoginMain/eaSignup/routes.js";
import eaSignupCompleteModule from "modules/eaLoginMain/eaSignupComplete/routes.js";
import eaConfirmIdentityModule from "modules/eaLoginMain/eaConfirmIdentity/routes.js";
import eaProtectBuyRegistrationModule from "modules/eaLoginMain/eaProtectBuyRegistration/routes.js";
import eaKnowYourCustomerModule from "modules/eaLoginMain/eaKnowYourCustomer/routes.js";
import eaSignupDoneModule from "modules/eaLoginMain/eaSignupDone/routes.js";
import eaIdentityConfirmedModule from "modules/eaLoginMain/eaIdentityConfirmed/routes.js";
import eaVerifyNewsletterModule from "modules/eaLoginMain/eaVerifyNewsletter/routes.js";
import eaProtectBuyConfirmedModule from "modules/eaLoginMain/eaProtectBuyConfirmed/routes.js";
import eaCookieSettingsModule from "modules/eaLoginMain/eaCookieSettings/routes.js";

import eaUserModule from "modules/eaSettings/eaUser/routes.js";
import eaRoleModule from "modules/eaSettings/eaRole/routes.js";
import eaProfileModule from "modules/eaSettings/eaProfile/routes.js";
import eaNotificationModule from "modules/eaSettings/eaNotification/routes.js";
import eaPeriodicDownloadModule from "modules/eaSettings/eaPeriodicDownload/routes.js";
import eaCardDetailsModule from "modules/eaSettings/eaCardDetails/routes.js";
import eaTransactionModule from "modules/eaTransaction/routes.js";
import eaCardModule from "modules/eaCard/routes.js";
import eaInvoiceModule from "modules/eaInvoice/routes.js";
import eaExchangeRateModule from "modules/eaExchangeRate/routes.js";
import eaMessageIn from "modules/eaMessage/eaMessageInbox/routes.js";
import eaMessageOut from "modules/eaMessage/eaMessageOutbox/routes.js";

import eaEMailsModule from "modules/eaAdministration/eaEMails/routes.js";
import eaAcivitiesModule from "modules/eaAdministration/eaActivities/routes.js";
import eaKnowYourCustomerAdministrationModule from "modules/eaAdministration/eaKnowYourCustomer/routes.js";

import ocLazyLoad from "app/services/ocLazyLoad.js";
import dynamicLocale from "app/services/dynamicLocale.js";
import lastRepeat from "app/directives/last-repeat.js";
import money from "app/filter/money";

import dcDebounce from "app/services/dc-debounce";
import dcFormLocator from "app/directives/dcFormLocator";
import ngScopeElement from "app/directives/ngScopeElement";
import propsFilter from "app/filter/propsFilter";
import focusMe from "app/directives/focusMe";

import compile from "app/directives/compile";

import addBlockRequestInterceptor from "app/interceptors/blockRequestInterceptor";

import "app/services/bootstrap";

// import socketIo from "app/services/socket.io.js";

import "@babel/polyfill";

var dependencies = [
  cookieLaw,
  analytics,
  logging,
  angularLoadingBar,
  // socketIo,
  ocLazyLoad,
  uiRouter,
  ngMessages,
  ngAnimate,
  ngSanitize,
  ngCookies,
  matchmedia,
  dynamicLocale,
  ConfigService,
  RequestService,
  LocaleService,
  SyscodeService,
  MenuService,
  AuthenticationService,
  SessionExpirationService,
  MaintenanceService,
  FeatureService,
  HeaderComponent,
  UserComponent,
  DemoModeService,
  Events,
];

angular
  .module("app", dependencies)
  .config(routes)
  .config(config)
  .config(() => {
    angular.lowercase = (text) => (text ? text.toLowerCase() : text);
  })
  .config([
    "$qProvider",
    function ($qProvider) {
      $qProvider.errorOnUnhandledRejections(false);
    },
  ])
  .config([
    "$locationProvider",
    function ($locationProvider) {
      $locationProvider.hashPrefix("");
    },
  ])
  // NEU **  .config(loginRoutes)
  //  .config(dashboardRoutes)
  .config(dashboardModule)

  .config(eaLoginMainModule)
  .config(eaChangeEmailModule)
  .config(eaAddContractVerificationModule)
  .config(eaForgotEmailModule)
  .config(eaForgotPasswordModule)
  .config(eaLoginModule)
  .config(eaNotAvailableModule)
  .config(eaRegisterModule)
  .config(eaResetPasswordModule)
  .config(eaSignupModule)
  .config(eaSignupCompleteModule)
  .config(eaConfirmIdentityModule)
  .config(eaProtectBuyRegistrationModule)
  .config(eaKnowYourCustomerModule)
  .config(eaSignupDoneModule)
  .config(eaIdentityConfirmedModule)
  .config(eaVerifyNewsletterModule)
  .config(eaProtectBuyConfirmedModule)
  .config(eaCookieSettingsModule)

  .config(eaUserModule)
  .config(eaRoleModule)
  .config(eaProfileModule)
  .config(eaNotificationModule)
  .config(eaPeriodicDownloadModule)
  .config(eaCardDetailsModule)
  .config(eaTransactionModule)
  .config(eaInvoiceModule)
  .config(eaCardModule)
  .config(eaExchangeRateModule)
  .config(eaMessageIn)
  .config(eaMessageOut)
  .config(eaEMailsModule)
  .config(eaAcivitiesModule)
  .config(eaKnowYourCustomerAdministrationModule)
  //.config(exceptionHandler)
  .directive("compile", compile)
  .directive("dcFormLocator", dcFormLocator)
  .directive("lastRepeat", lastRepeat)
  .directive("ngScopeElement", ngScopeElement)
  .directive("focusMe", focusMe)
  .factory("dcDebounce", dcDebounce)
  .filter("money", money)
  .filter("propsFilter", propsFilter)
  .factory("httpCanceler", httpCanceler)
  .factory("httpInterceptor", httpInterceptor)
  .factory("httpRequestInterceptor", httpRequestInterceptor)
  .filter("propsFilter", propsFilter)
  .filter("dt", dtFilter)
  .filter("date", dtFilter)
  .filter("i18n", i18nFilter)
  .filter("i18nNoBr", i18nNoBrFilter)
  .directive("i18n", i18nDirective)
  .controller("AppController", AppController)
  .controller("ErrorPageController", ErrorPageController)
  .run(addBlockRequestInterceptor)
  .run([
    "$templateCache",
    "$window",
    function ($templateCache, $window) {
      $templateCache.put(
        "errors.tpl.html",
        require("./app/errors/errors.tpl.html")
      );
      $templateCache.put(
        "mailerrors.tpl.html",
        require("./app/errors/mailerrors.tpl.html")
      );
      $templateCache.put(
        "checkboxerrors.tpl.html",
        require("./app/errors/checkboxerrors.tpl.html")
      );
    },
  ]);



// WEBPACK FOOTER //
// ./src/ui/app.js